// @ts-expect-error - Global variable for webpack, must be imported in all entry points
__webpack_public_path__ = process.env.ROOT_PATH;
